import "./Graficos.css";
import React, { useEffect, useState } from "react";
import CargandoSpinner from "../0. Utilidades/loadingSpinner"; // Import the spinner component
import { Bar, Pie } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

// Register the components and the plugin
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels,
);

const Graficos = () => {
  const [regionData, setRegionData] = useState([]);
  const [oficioData, setOficioData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BASE_API}api/graficos/`)
      .then((response) => response.json())
      .then((data) => {
        setRegionData(data.region_data);
        setOficioData(data.oficio_data);
        setLoading(false); // Set loading to false after data is fetched
      })
      .catch((error) => {
        console.error("There was an error fetching the data!", error);
        setLoading(false); // Set loading to false even if there is an error
      });
  }, []);

  // Prepare region data for the bar chart
  const regionLabels = regionData.map((item) => item.label);
  const regionCounts = regionData.map((item) => item.value);

  // Prepare oficio data for the pie chart
  const oficioLabels = oficioData.map((item) => item.label);
  const oficioCounts = oficioData.map((item) => item.value);

  const totalOficioCount = oficioCounts.reduce((sum, value) => sum + value, 0);

  const regionChartData = {
    labels: regionLabels,
    datasets: [
      {
        label: "N° de Maestras",
        data: regionCounts,
        backgroundColor: "rgba(75, 192, 192, 0.2)",
        borderColor: "rgba(75, 192, 192, 1)",
        borderWidth: 1,
      },
    ],
  };

  const oficioChartData = {
    labels: oficioLabels,
    datasets: [
      {
        label: "N° de Maestras",
        data: oficioCounts,
        backgroundColor: oficioLabels.map(
          () =>
            `rgba(${Math.floor(Math.random() * 255)}, ${Math.floor(Math.random() * 255)}, ${Math.floor(Math.random() * 255)}, 0.5)`,
        ),
        borderColor: oficioLabels.map(
          () =>
            `rgba(${Math.floor(Math.random() * 255)}, ${Math.floor(Math.random() * 255)}, ${Math.floor(Math.random() * 255)}, 1)`,
        ),
        borderWidth: 1,
      },
    ],
  };

  const barChartOptions = {
    indexAxis: "y", // Invert the axes
    scales: {
      x: {
        suggestedMax: 100, // Set maximum value for x-axis
      },
    },
    plugins: {
      legend: {
        display: false, // Disable the legend
      },
      datalabels: {
        anchor: "start",
        align: "end",
        offset: 0,
        font: {
          weight: "bold",
        },
        formatter: (value, context) => {
          if (value === 0) {
            return ""; // Return empty string if value is 0
          }
          const percentage = ((value / totalOficioCount) * 100).toFixed(1); // Calculate percentage
          return `${percentage}%`; // Return percentage
        },
      },
    },
    maintainAspectRatio: false, // Disable aspect ratio to control the size
    responsive: true, // Ensure the chart is responsive
  };

  const pieChartOptions = {
    plugins: {
      legend: {
        position: "left", // Place legend at the bottom
      },
      datalabels: {
        formatter: (value, context) => {
          const percentage = ((value / totalOficioCount) * 100).toFixed(1); // Calculate percentage
          return `${percentage}%`; // Return percentage
        },
        color: "#000", // Black labels for better visibility
        anchor: "end", // Position data labels outside the pie
        align: "end", // Align the labels outside the chart
        offset: -50, // Move labels away from the chart
        font: {
          weight: "bold",
        },
      },
    },
    maintainAspectRatio: false, // Disable aspect ratio to control the size
    responsive: true, // Ensure the chart is responsive
  };

  return (
    <div id="graficos">
      <h3>Estadisticas</h3>
      {loading ? (
        <CargandoSpinner /> // Show spinner while loading
      ) : (
        <div className="graficos">
          <div className="chart-region">
            <Bar data={regionChartData} options={barChartOptions} />
          </div>
          <div className="chart-oficio">
            <Pie data={oficioChartData} options={pieChartOptions} />
          </div>
        </div>
      )}
    </div>
  );
};

export default Graficos;
